import React from "react";
import { zeroPad } from "../../utils";

interface Props {
  startTimestamp: number;
}

interface State {
  elapsedSeconds: number;
}

export class CallTimer extends React.Component<Props, State> {
  private timer?: number;

  constructor(props: Props) {
    super(props);

    this.state = { elapsedSeconds: this.getElapsedSecond() };
  }

  componentDidMount() {
    this.timer = window.setInterval(this.tick.bind(this), 500);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  private getElapsedSecond() {
    return Math.floor((Date.now() - this.props.startTimestamp) / 1000);
  }

  private tick() {
    this.setState({ elapsedSeconds: this.getElapsedSecond() });
  }

  formatTime(): string {
    const t = this.state.elapsedSeconds;
    const min = Math.floor(t / 60);
    const sec = t - min * 60;
    return zeroPad(min, 2) + ":" + zeroPad(sec, 2);
  }

  render() {
    return <span>{this.formatTime()}</span>;
  }
}
